import { TopLogoViewFg } from "@quest/murka-games-behavior-panther/dist/Game/TopLogo/TopLogoViewFg";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { dispatcher } from "@quest/base-core";

export class TopLogoViewFgGame extends TopLogoViewFg {
  /**to udpate the pivot as of basegame */
  public topSpace(): void {
    super.topSpace()
    if (this.currentStateView) {
      dispatcher.fireEvent(eventDispatchers.ADD_BANNER_ON_TOP);
      const logoHeightBg = this.getShapeById("logoHeightBg");
      this.pivot.set(logoHeightBg.width / 2, logoHeightBg.height / 2);
    }
  }
}